export const environment = {
	production: false,
	BasemapCustomStyleId: "5b062c80a4cf4f14a7b429f42295d2e8",
	Version: "16.187",
	ApplicationInsightsConnectionString: 'InstrumentationKey=085f1569-0104-4c41-a99a-53d1be0aab48;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=a10e65e4-0037-4f43-8a8f-af13905121ae',
	DriverFileMaximumFragmentByteSize: 50000,
	RepromptForUpgradeIntervalMilliseconds: 300000
};
